
<template>
  <div v-if="result !== false">
    <v-layout
      wrap
      v-for="(item, i) in result"
      :key="i"
      justify-center
      text-center
    >
      <v-flex xs12> </v-flex>
      <v-flex xs12>
        {{ item.comment }}
      </v-flex>
      <v-flex xs12>
        {{ item.condition }}
      </v-flex>
      <v-flex xs3>
        <v-img
          width="507px"
          height="314px"
          cover
          :src="mediaURL + item.image"
        ></v-img>
      </v-flex>
      <v-flex xs12>
        {{ item.turtle.common_name }}
      </v-flex>
      <v-flex>
        {{ item.turtle.habitat }}
      </v-flex>
    </v-layout>
  </div>
  <div v-else>
    <v-layout wrap justify-center>
      <v-flex text-center align-self-center>
        <span>Sorry!!No result found</span>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["keyword"],
  data() {
    return {
      result: [],
    };
  },
  watch: {
    keyword() {
      this.getNorm();
    },
  },
  mounted() {
    // this.$root.$on("getNorm", () => {
    //   return this.getNorm();
    // });
    this.getNorm();
  },
  methods: {
    getNorm() {
    //   if (this.keyword) {
        axios({
          method: "GET",
          url: "report/search",
          params: {
            keyword: this.keyword,
          },
        })
          .then((response) => {
            if (response.data.status == true) {
              this.result = response.data.data;
            } else {
            this.result = response.data.status;
            console.log(response.data.status)
            }
          })
          .catch((err) => {
            console.log(err());
          });
    //   }
    },
  },
};
</script>